import { render, staticRenderFns } from "./BagList.vue?vue&type=template&id=e78a2b9a&"
import script from "./BagList.vue?vue&type=script&lang=js&"
export * from "./BagList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports